import React from "react"
import cx from "classnames"

import { InterviewCard } from "../../components"
import { GridCol4 } from "../../layout"
import { GraphCms_Interview } from "../../../../graphql-types"

type Props = {
  className?: string
  interviews: GraphCms_Interview[]
}

function InterviewList({ className, interviews }: Props) {
  return (
    <GridCol4 className={cx(className)}>
      {interviews.map((interview: GraphCms_Interview) => {
        return <InterviewCard key={interview.id} interview={interview} />
      })}
    </GridCol4>
  )
}

export default InterviewList
